import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState } from "../utils";

const useSignUpStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      updateNewUser: (action, param) => set({ newUser: updateObjectState(get().newUser, action, param) }),
      resetSignUp: () => set(initialState), // Reset function
    })),
    {
      name: "pearl-signUp", //name of store, must be unique
      //storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useSignUpStore;
